export enum MaterialListStatus {
  ceased = 'ceased',
  active = 'active',
  updated = 'updated',
  deleted = 'deleted',
  added = 'added',
}

type MasterListJournalAction = 'updated' | 'deleted' | 'added';

interface MasterListJournalDelta {
  name?: string;
  url?: string;
  publishing_model?: string;
  imprint?: string;
  publisher?: string;
  issn_e?: string;
  issn_p?: string;
  subjects?: string;
  licenses?: string[];
}

export type MasterListJournal = {
  id: string;
  name: string;
  url: string;
  publishing_model: string;
  issn_e?: string;
  issn_p?: string;
  publisher?: string;
  imprint?: string;
  subjects?: string;
  licenses?: string[];
  updated_at?: string;
  updated_by?: string;
  status?: MaterialListStatus | null;
};

export type MasterListJournalRequestBody = {
  id?: string;
  delta?: {
    name?: string;
    url?: string;
    publishing_model?: string;
    imprint?: string;
    publisher?: string;
    issn_e?: string;
    issn_p?: string;
    subjects?: string;
    licenses?: string[];
  };
  action: MasterListJournalAction;
  change_message: string;
};

export type MasterListFilter = {
  publishers: string[];
  imprints: string[];
  licenses: string[];
  publishingModels: string[];
  statuses: string[];
};

export type MasterListFilterKeys = keyof MasterListFilter;

export type MasterListStatusResponse = {
  pending_changes: number;
};

export type MasterListJournalHistory = {
  id: string;
  journal_id: string;
  action: MasterListJournalAction;
  delta: Partial<MasterListJournalDelta>;
  change_message: string;
  updated_at: string;
  updated_by: string;
  sequence?: number;
  pending: boolean;
};

export type MasterListJournalHistoryResponse = MasterListJournalHistory[];

export type ExportMasterListView = 'clean' | 'effective';
